import { render } from "./index.vue?vue&type=template&id=6fced4c3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6fced4c3&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6fced4c3"

export default script